import { render, staticRenderFns } from "./dashboardIndex.vue?vue&type=template&id=11525e30&"
import script from "./dashboardIndex.vue?vue&type=script&lang=js&"
export * from "./dashboardIndex.vue?vue&type=script&lang=js&"
import style0 from "./dashboardIndex.vue?vue&type=style&index=0&id=11525e30&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports